import { Box, Typography } from '@mui/material';
import NoDataPresentUI from '../../components/NoDataPresentUI';

function ConfirmationScreen({ content = <></>, footerButton , containerStyle = {} }) {
    return (
        <>
            <NoDataPresentUI
                variant={'outlined'}
                containerSx={{
                    width: {
                        xs: '100%',
                        sm: '100%',
                        md: '100%',
                    },
                    height: '20rem',
                    ...containerStyle
                }}
                heading={content}
                footerButton={footerButton}
            />
        </>
    );
}

export default ConfirmationScreen;
